import createModel from "@/__main__/data-model.mjs";

const model = { id: String };

const transform = createModel({ matches: [model] });

export const fixture = {
  matches: new Array(50).fill(null).map((_, i) => {
    return {
      id: `${i}`,
    };
  }),
};

export default transform;
